module.exports = __webpack_public_path__ + "img/sprinkle-3.057c3b36.jpg";